
import { Button } from "@/components/ui/button";

interface EmailConfirmationMessageProps {
  membershipType?: "active" | "benefactor" | "donor";
}

export function EmailConfirmationMessage({ membershipType }: EmailConfirmationMessageProps) {
  const isDonor = membershipType === "donor";
  
  return (
    <div className="bg-white p-8 rounded-lg shadow-md text-center">
      <h2 className="text-2xl font-bold text-[#00123A] mb-4">
        {isDonor 
          ? "Merci pour votre don !" 
          : "Merci pour votre demande d'adhésion !"}
      </h2>
      <p className="mb-6">
        Un email de confirmation a été envoyé à l'adresse que vous avez indiquée.
        Veuillez vérifier votre boîte de réception et suivre les instructions pour finaliser votre {isDonor ? "don" : "adhésion"}.
      </p>
      <Button variant="default" className="bg-[#00123A]" onClick={() => window.location.href = "/"}>
        Retour à l'accueil
      </Button>
    </div>
  );
}
